import * as angular from "angular";
import * as _ from "lodash";
import {IQService} from "angular";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";
import {PricePlanAlertsService} from "./price-plan-alerts.service";
import {PricePlanBundleRequestsService} from "./price-plan-bundle-requests.service";
import {PricePlanDialogService} from "./price-plan-dialog-service.service";

export class PricePlanBundleActionsService {
  constructor(private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private $q: IQService, private pricePlanAlertsService: PricePlanAlertsService, private $state, private confirmDialogService: ConfirmDialogService,
              private pricePlanDialogService: PricePlanDialogService, private $log) {
  }

  createChildBundle(event, parentId) {
    const deferred = this.$q.defer();

    this.pricePlanDialogService.createChildPricePlan(event).then(
      (bundleResult) => {
        const payload = {
          name: bundleResult.name,
          parentId: parentId
        };

        this.pricePlanBundleRequestsService.createBundle(payload).then(
          (bundle) => {
            deferred.resolve(bundle);
            this.pricePlanAlertsService.createSuccess();
            // const bundleId = _.get(bundle, 'id');
            // if (bundleId) {
            //   this.$state.go('pricePlanDetails', {id: bundleId});
            // }
          }
        ).catch((error) => {
          this.pricePlanAlertsService.createError();
          deferred.reject(error);
        });

      }).catch(() => deferred.reject);

    return deferred.promise;
  }

  duplicateBundle(event, bundle) {
    const deferred = this.$q.defer();

    this.pricePlanDialogService.duplicateBundle(event, bundle).then(
      (bundleName) => {
        const duplicateBundle = {
          name: bundleName
        };

        this.pricePlanBundleRequestsService.duplicateBundle(bundle.id,
          duplicateBundle).then((bundle) => {
            deferred.resolve(bundle);
            this.pricePlanAlertsService.duplicateSuccess();
            // const bundleId = _.get(bundle, 'id');
            // const firstActiveProgramType = _.find(bundle.entryList, (pt) => {
            //   return pt.enabled;
            // });
            //
            // if (bundleId) {
            //   this.$state.go('pricePlanDetails.service',
            //     {
            //       pricePlanBundleId: bundleId,
            //       programId: firstActiveProgramType.id,
            //     });
            // }
          }
        )
          .catch((error) => {
            this.pricePlanAlertsService.duplicateError();
            deferred.reject(error);
          });

      }
    ).catch(() => deferred.reject);

    return deferred.promise;
  }

  editChildBundleName(ev, bundle) {
    return this.confirmDialogService.confirm('Edit Price Plan Bundle Name', 'Enter bundle name', ev)
      .then((result) => {
        const newBundle = {id: bundle.id, name: result};

        return this.pricePlanBundleRequestsService.editBundle(newBundle);
      })
      .then((res) => {
        this.pricePlanAlertsService.updateSuccess();
        return res;
      });
  }

  editPricePlanBundle(event, bundle, loading, accountId) {
    //TODO any validations required??

    const deferred = this.$q.defer();

    this.pricePlanDialogService.editPricePlanBundle(event, bundle, accountId).then(
      (result) => {

        loading = true;

        if (!_.isEmpty(result)) {
          const bundleId = _.get(result, 'id');

          this.pricePlanBundleRequestsService.editBundle(bundleId, result, accountId).then(
            (updated) => {
              deferred.resolve(updated);
            }
          ).catch((_err) => {
            this.$log.debug('Error during price plan bundle edit! \n', _err);
            loading = false;
            deferred.reject(_err);
          });

        } else {
          loading = false;

          this.$log.error('Price plan edit dialog result resolved to an empty object. \n' +
            'Possible cause is empty bundle object passed or misuse of the function. \n' +
            '--> pricePlanBundleActionsService@editPricePlanBundle');
          deferred.reject();
        }

      }
    ).catch(() => deferred.reject);

    return deferred.promise;
  }

  setAsDefault(ev, id, name) {
    return this.confirmDialogService.confirm('Set default Price Plan', 'Are you sure you want to select ' + name + ' as the default Price plan.', ev)
      .then(() => {
        return this.pricePlanBundleRequestsService.setAsDefault(id);
      })
      .then(() => {
        this.pricePlanAlertsService.setDefaultSuccess();
      });
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanBundleActionsService', PricePlanBundleActionsService);
